module.exports = __webpack_public_path__ + "img/21_45.20bf3e7b.png";